import { icon, label } from "../../../../config";

export const SplitButtonConfigs = {
  HOME: {
    itemId: "addTask",
    text: label.ADD_TASK,
    icon: icon.ADD_TASK_APP,
    title: "Ctrl + D",
    items: [{ id: "addReminder", text: label.ADD_REM, icon: icon.BELL_ICON }],
  },

  INVITE_USER: {
    itemId: "addUser",
    text: label.INVITE_USER,
    icon: icon.INVITE_USERS,
    items: [
      { id: "addTask", text: label.ADD_TASK, icon: icon.ADD_TASK_APP },
      { id: "addReminder", text: label.ADD_REM, icon: icon.BELL_ICON },
    ],
  },

  REMINDER: {
    itemId: "addReminder",
    text: label.ADD_REM,
    icon: icon.BELL_ICON,
    items: [{ id: "addTask", text: label.ADD_TASK, icon: icon.ADD_TASK_APP }],
  },
  SUPER_ADMIN_STREAM: {
    itemId: "addSuperAdminStream",
    text: "Add Stream",
    icon: icon.STREAM_ICON,
    items: [
      { id: "addTask", text: label.ADD_TASK, icon: icon.ADD_TASK_APP },
      { id: "addReminder", text: label.ADD_REM, icon: icon.BELL_ICON },
    ],
  },
  WORKSPACE_STREAM: {
    itemId: "addWorkspaceStream",
    text: "Add Stream",
    icon: icon.STREAM_ICON,
    items: [
      { id: "addTask", text: label.ADD_TASK, icon: icon.ADD_TASK_APP },
      { id: "addReminder", text: label.ADD_REM, icon: icon.BELL_ICON },
    ],
  },
  TEAM_STREAM: {
    itemId: "addTeamStream",
    text: "Add Stream",
    icon: icon.STREAM_ICON,
    items: [
      { id: "addTask", text: "Add Task", icon: icon.ADD_TASK_APP },
      { id: "addReminder", text: label.ADD_REM, icon: icon.BELL_ICON },
    ],
  },

  ADD_WORKFLOW: {
    itemId: "addWorkflow",
    text: "Add Workflow",
    icon: icon.WORKFLOW_LUCID,
    items: [
      { id: "addTask", text: "Add Task", icon: icon.ADD_TASK_APP },
      { id: "addReminder", text: label.ADD_REM, icon: icon.BELL_ICON },
    ],
  },

  ADD_AUTOMATION: {
    itemId: "addAutomation",
    text: "Add Automation",
    icon: icon.TRIGGERED_TASKS,
    items: [
      { id: "addTask", text: "Add Task", icon: icon.ADD_TASK_APP },
      { id: "addReminder", text: label.ADD_REM, icon: icon.BELL_ICON },
    ],
  },

  ADD_FORM: {
    itemId: "addForm",
    text: "Add Form",
    icon: icon.FORM_ADD,
    items: [
      { id: "addTask", text: "Add Task", icon: icon.ADD_TASK_APP },
      { id: "addReminder", text: label.ADD_REM, icon: icon.BELL_ICON },
    ],
  },

  ADD_FILTER: {
    itemId: "addFilter",
    text: "Add View",
    icon: icon.FILTER_ICON,
    items: [
      { id: "addTask", text: "Add Task", icon: icon.ADD_TASK_APP },
      { id: "addReminder", text: label.ADD_REM, icon: icon.BELL_ICON },
    ],
  },

  ADD_CHIP: {
    itemId: "addChip",
    text: "Add Chip",
    icon: icon.SMART_CHIP,
    mainMenuItems: [
      { id: "addGlobalChip", text: "Global Chip", icon: icon.SMART_CHIP },
      { id: "addProjectChip", text: (name) => `${name || "Project"} Chip`, icon: icon.SMART_CHIP },
    ],
    items: [
      { id: "addTask", text: "Add Task", icon: icon.ADD_TASK_APP },
      { id: "addReminder", text: label.ADD_REM, icon: icon.BELL_ICON },
    ],
  },

  ADD_TEAM: {
    itemId: "addTeam",
    text: (name) => `Join ${name || label.TEAM}`,
    icon: icon.ADD_CIRCLE_ICON,
    items: [
      { id: "addTeam", testId: "header-add-team", text: (name) => `Add ${name || label.TEAM}`, icon: icon.GROUPS_ICON },
      { id: "addTask", text: "Add Task", icon: icon.ADD_TASK_APP },
      { id: "addReminder", text: label.ADD_REM, icon: icon.BELL_ICON },
    ],
  },

  MANAGE_PROJECTS_TEAM: {
    itemId: "manageProjectsAddProject",
    text: (name) => `Add ${name || label.TEAM}`,
    icon: icon.GROUPS_ICON,
    items: [
      { id: "manageProjectsJoinProject", text: (name) => `Join ${name || label.TEAM}`, icon: icon.ADD_CIRCLE_ICON },
      { id: "addTask", text: "Add Task", icon: icon.ADD_TASK_APP },
      { id: "addReminder", text: label.ADD_REM, icon: icon.BELL_ICON },
    ],
  },

  ADD_WORKSPACE: {
    itemId: "addWorkspace",
    text: "Add Space",
    items: [
      { id: "addTask", text: "Add Task", icon: icon.ADD_TASK_APP },
      { id: "addReminder", text: label.ADD_REM, icon: icon.BELL_ICON },
    ],
  },

  ADD_MEMBER: {
    itemId: "addMember",
    text: "Add Member",
    icon: icon.ADD_USERS,
    items: [
      { id: "addTask", text: "Add Task", icon: icon.ADD_TASK_APP },
      { id: "addReminder", text: label.ADD_REM, icon: icon.BELL_ICON },
    ],
  },

  ADD_JOB_ROLE: {
    itemId: "addJobRole",
    text: "Add Job Role",
    icon: icon.ADD_JOB_ROLE,
    items: [
      { id: "addTask", text: label.ADD_TASK, icon: icon.ADD_TASK_APP },
      { id: "addReminder", text: label.ADD_REM, icon: icon.BELL_ICON },
    ],
  },

  ADD_TAG: {
    itemId: "addTag",
    text: "Add Tag",
    icon: icon.TAG_ICON,
    items: [
      { id: "addTask", text: label.ADD_TASK, icon: icon.ADD_TASK_APP },
      { id: "addReminder", text: label.ADD_REM, icon: icon.BELL_ICON },
    ],
  },

  ADD_BUSINESS_UNIT: {
    itemId: "addBusinessUnit",
    text: "Add Business Unit",
    icon: icon.BUSINESS_UNIT,
    items: [
      { id: "addTask", text: label.ADD_TASK, icon: icon.ADD_TASK_APP },
      { id: "addReminder", text: label.ADD_REM, icon: icon.BELL_ICON },
    ],
  },

  ADD_COST_CENTER: {
    itemId: "addCostCenter",
    text: "Add Cost Center",
    icon: icon.COST_CENTER_APP,
    items: [
      { id: "addTask", text: label.ADD_TASK, icon: icon.ADD_TASK_APP },
      { id: "addReminder", text: label.ADD_REM, icon: icon.BELL_ICON },
    ],
  },

  ADD_DEPARTMENT: {
    itemId: "addDepartment",
    text: "Add Department",
    icon: icon.ADD_DEPARTMENT,
    items: [
      { id: "addTask", text: label.ADD_TASK, icon: icon.ADD_TASK_APP },
      { id: "addReminder", text: label.ADD_REM, icon: icon.BELL_ICON },
    ],
  },

  ADD_OFFICE_LOCATION: {
    itemId: "addOfficeLocation",
    text: "Add Office Location",
    icon: icon.ADD_OFFICE_LOCATION,
    items: [
      { id: "addTask", text: label.ADD_TASK, icon: icon.ADD_TASK_APP },
      { id: "addReminder", text: label.ADD_REM, icon: icon.BELL_ICON },
    ],
  },

  ADD_GROUP: {
    itemId: "addGroup",
    text: "Add Group",
    icon: icon.ADD_GROUP,
    items: [
      { id: "addTask", text: label.ADD_TASK, icon: icon.ADD_TASK_APP },
      { id: "addReminder", text: label.ADD_REM, icon: icon.BELL_ICON },
    ],
  },

  ADD_FIELD: {
    itemId: "addField",
    text: "Add Chip",
    icon: icon.MICROCHIP,
    items: [
      { id: "addTask", text: label.ADD_TASK, icon: icon.ADD_TASK_APP },
      { id: "addReminder", text: label.ADD_REM, icon: icon.BELL_ICON },
    ],
  },

  ADD_API: {
    itemId: "addApi",
    text: "Add API",
    icon: icon.API_ACTIVE,
    items: [
      { id: "addTask", text: label.ADD_TASK, icon: icon.ADD_TASK_APP },
      { id: "addReminder", text: label.ADD_REM, icon: icon.BELL_ICON },
    ],
  },

  ADD_TIME_BLOCK: {
    itemId: "addTimeBlock",
    text: "Add Time Block",
    icon: icon.TIME_BLOCK_ICON,
    items: [
      { id: "addTask", text: label.ADD_TASK, icon: icon.ADD_TASK_APP },
      { id: "addReminder", text: label.ADD_REM, icon: icon.BELL_ICON },
    ],
  },
};
